import { HomeIcon } from '@components/icons/home-icon';
import { useTranslation } from 'next-i18next';
import { useAtom } from 'jotai';
import { MinicartIcon } from '@components/icons/new/minicart-icon';
import { RootState } from 'src/root-redux/store';
import { useDispatch, useSelector } from 'react-redux';
import { ROUTES } from '@lib/routes';
import { AccountIcon } from '@components/icons/account-icon';
import cn from 'classnames';
import router from 'next/router'
import { toast } from 'react-toastify';
import { drawerAtom } from '@store/drawer-atom';
import { formatCartSubtotal } from '@lib/format-number';
import { CategoriesIcon } from '@components/icons/new/categories-icon';
import { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import HeaderCloseMenuCategoriesIcon from '@components/icons/new/header-close-menu-categories-icon';
import CategoriesMenu from './menu/categories-menu';
import IndustriesMenu from './menu/industries-menu';
import MiniShopIcon from '@components/icons/new/mini-shop-icon';
import { ShopIcon } from '@components/icons/shop-icon';
import { CategoriesActiveIcon } from '@components/icons/new/categories-active-icon';
import { HomeIconInactive } from '@components/icons/home-icon-inactive';
import { AccountIconActive } from '@components/icons/account-icon-active';
import { MinicartIconActive } from '@components/icons/new/minicart-icon-active';
import { getPaymentInfo } from '@lib/cart';
import { initCartData } from '@components/cart/cartSlice';

type DivElementRef = React.MutableRefObject<HTMLDivElement>;

const MobileNavigation: React.FC = () => {
  const { t } = useTranslation('common');
  const pathname = router.asPath;
  const [displayCart, setDisplayCart] = useAtom(drawerAtom);
  const [active, setActive] = useState(false);
  const ref = useRef() as DivElementRef;
  const menuShopRef = useRef() as DivElementRef;
  const handleToggle = useCallback((e: any) => {
    e.preventDefault();
    setActive((active) => !active);
  }, []);

  const [activeMenuShop, setActiveMenuShop] = useState(false);
  const handleToggleMenuShop = useCallback((e: any) => {
    e.preventDefault();
    setActiveMenuShop((activeMenuShop) => !activeMenuShop);
  }, []);
  const {
    cart: {cartShops},
    i33Settings: { isMobileOnly },
    authenticationSettings: { isAuthorize }
  } = useSelector((state: RootState) => state);
  // const { cartShops }: any = useSelector((state: RootState) => state.cart);
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(initCartData())
  }, [])
  const cartPaymentInfoAll = getPaymentInfo({
    cart_shops: cartShops || [],
  });
  function handleCartSidebar() {
    isAuthorize
      ? setDisplayCart({ display: true, view: 'cart' })
      : checkLogin(ROUTES.MOBILE_LOGIN);
  }

  function checkLogin(targetUrl: any) {
    if (isAuthorize) {
      router.push(targetUrl);
    } else {
      toast.error(t('authentication-required'));
      router.push(ROUTES.MOBILE_LOGIN);
    }
  }

  return (<div className="visible sm:hidden h-[66px] w-full header-transport-wishlist-minicart be-viet-pro">
    <meta name="viewport" content="height=device-height,
                                   width=device-width, initial-scale=1.0,
                                   minimum-scale=1.0, maximum-scale=1.0,
                                   user-scalable=no, target-densitydpi=device-dpi" />
    { isMobileOnly && <ul className="flex flex-wrap justify-between h-[66px] w-full md:h-14 start-0 bg-light fixed py-2.5 px-1 shadow-md shadow-menu-mobile bottom-0 z-[2000]">
      <li className="li--minicart content-center justify-items-center text-align-webkit-center">
        <span
          onClick={() => router.push(ROUTES.HOME)}
          className="btn-minicart-header display-moble-navigator cursor-pointer mt-[3px]"
        >
          <div>
            {pathname == '/' && !active && !activeMenuShop && !displayCart.display ? <HomeIcon stroke='#6AA543' /> : <HomeIconInactive />}
          </div>
          <span className={cn('text-xs', pathname == '/' && !active && !activeMenuShop && !displayCart.display && 'text-accent')}>{t('text-home')}</span>
        </span>
      </li>
      <li className="li--minicart">
        <span onClick={() =>  {
          setActive(!active)
          setActiveMenuShop(false)
        }} className="btn-notification-header btn-wishlist-header-mobile display-moble-navigator mt-[3px]">
          {
            active ? <CategoriesActiveIcon /> :  <CategoriesIcon />
          }
          <span className={cn('text-xs', active ? 'text-accent' : 'text-gray-1500')}>{t('text-categories')}</span>
        </span>
      </li>
      <li className="li--minicart">
        <button className="btn-minicart-header btn-wishlist-header text-align-webkit-center display-moble-navigator mt-[3px]" onClick={handleCartSidebar}>
          {isAuthorize && <span className="count left-30-important cart-subtotal">{isAuthorize ? formatCartSubtotal(String(cartPaymentInfoAll.subtotal ||  0)) : 0}</span>}
          <span>{displayCart.display ? <MinicartIconActive /> : <MinicartIcon width='21' height='20' />}</span>
          <span className="text-xs">{t('header-cart')}</span>
        </button>
      </li>
      <li className="li--minicart">
        <span onClick={() => {
          setActive(false)
          setActiveMenuShop(!activeMenuShop)
        }} className="text-align-webkit-center display-moble-navigator">
          <span>{activeMenuShop ? <ShopIcon /> : <MiniShopIcon />}</span>
          <span className={cn('text-xs', activeMenuShop ? 'text-accent' : 'text-gray-1500')}>{t('text-store-title')}</span>
        </span>
      </li>
      <li className='li--minicart'>
        <span onClick={() => {router.push(ROUTES.ACCOUNT)}} className="text-align-webkit-center display-moble-navigator">
          <span>{pathname.includes('/mobile-account') && !active && !activeMenuShop && !displayCart.display  ? <AccountIconActive /> : <AccountIcon stroke='#818898' />}</span>
          <span className={cn('text-xs', pathname.includes('/mobile-account') && !active && !activeMenuShop && !displayCart.display ? 'text-accent' : 'text-gray-1500')}>{t('text-account')}</span>
        </span>
      </li>
    </ul>
    }

    <div
      ref={ref}
      className={
        active
          ? `aside-extra-menu--categories open-aside-extra-menu ${isMobileOnly ? "w-full" : "w-[350px]"}`
          : 'aside-extra-menu--categories'
      }
    >
      <div className="list-menu--categories">
        <div className="title">
          {t('header-menu-categories')}
          <div className="cursor-pointer" onClick={handleToggle}>
            <HeaderCloseMenuCategoriesIcon />
          </div>
        </div>
        <CategoriesMenu setActive={setActive} active={active} />
      </div>
    </div>
    <div
      onClick={handleToggle}
      className={
        active
          ? 'la-overlay-global la-overlay-global--active'
          : 'la-overlay-global'
      }
    ></div>
    <div
      ref={menuShopRef}
      className={
        activeMenuShop
          ? `aside-extra-menu--categories open-aside-extra-menu ${isMobileOnly && "w-full"}`
          : 'aside-extra-menu--categories'
      }
    >
      <div className="list-menu--categories">
        <div className="title">
          {t('header-shop-categories')}
          <div className="cursor-pointer" onClick={handleToggleMenuShop}>
            <HeaderCloseMenuCategoriesIcon width="24" height="24" />
          </div>
        </div>
        <IndustriesMenu activeMenuShop={activeMenuShop} setActiveMenuShop={setActiveMenuShop} />
      </div>
    </div>
    <div
      onClick={handleToggleMenuShop}
      className={
        activeMenuShop
          ? 'la-overlay-global la-overlay-global--active'
          : 'la-overlay-global'
      }
    ></div>
  </div>
  )
};

export default MobileNavigation;
